import { useParams } from 'react-router-dom';
import RedirectExternal from 'src/components/RedirectExternal/RedirectExternal';

/** Redirects a public `/attachment/:accessId` link to the env's API
 *  (`REACT_APP_BASE_API_URL`), which 302s to a fresh presigned S3 URL. */
export const AttachmentPage = () => {
  const { accessId } = useParams<{ accessId: string }>();
  const base = (process.env.REACT_APP_BASE_API_URL ?? '').replace(/\/+$/, '');
  const to = accessId ? `${base}/attachment/${encodeURIComponent(accessId)}` : undefined;
  return <RedirectExternal to={to} />;
};

export default AttachmentPage;
